/* index.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./index.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { fg } from '@atlaskit/platform-feature-flags';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import Select, { components } from '@atlaskit/select';
import { getDropDownMenuPosition } from '../../common/commonDropDownMenuProps';
import { messages } from './messages';
var containerStyles = xcss({
  display: 'flex',
  flexDirection: 'row'
});
var parentStyles = xcss({
  width: '50%',
  marginRight: 'space.100'
});
var childStyles = xcss({
  width: '50%'
});
var menuStyles = {
  menu: "_1pbyni7l"
};
export var EditCascadingDropdown = function EditCascadingDropdown(_ref) {
  var id = _ref.id,
    options = _ref.options,
    value = _ref.value,
    childOptions = _ref.childOptions,
    childValue = _ref.childValue,
    loading = _ref.loading,
    onChange = _ref.onChange,
    onChangeChild = _ref.onChangeChild,
    isRequired = _ref.isRequired,
    label = _ref.label;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: containerStyles
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: parentStyles
  }, /*#__PURE__*/React.createElement(EditDropdown, {
    id: id,
    options: options,
    value: value !== null && value !== void 0 ? value : null,
    loading: loading,
    onChange: onChange,
    clearable: true,
    isRequired: isRequired,
    label: label
  })), /*#__PURE__*/React.createElement(Box, {
    xcss: childStyles
  }, /*#__PURE__*/React.createElement(EditDropdown, {
    id: "".concat(id, "-child"),
    options: childOptions,
    value: childValue !== null && childValue !== void 0 ? childValue : null,
    loading: loading,
    onChange: onChangeChild,
    isRequired: isRequired,
    label: label
  })));
};
var EditDropdown = function EditDropdown(_ref2) {
  var id = _ref2.id,
    options = _ref2.options,
    value = _ref2.value,
    loading = _ref2.loading,
    onChange = _ref2.onChange,
    _ref2$clearable = _ref2.clearable,
    clearable = _ref2$clearable === void 0 ? false : _ref2$clearable,
    label = _ref2.label;
  return /*#__PURE__*/React.createElement(Select, _extends({
    id: id,
    key: id,
    options: options,
    value: value !== null && value !== void 0 ? value : null,
    isLoading: loading,
    onChange: onChange,
    isSearchable: true,
    isClearable: clearable,
    noOptionsMessage: function noOptionsMessage() {
      return /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownNoOptions);
    },
    placeholder: /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownSelect)
  }, getDropDownMenuPosition(), {
    label: label
  }, fg('jsm-request-intake-jac-fixes') ? {
    components: {
      Menu: function Menu(props) {
        return /*#__PURE__*/React.createElement(components.Menu, _extends({}, props, {
          xcss: menuStyles.menu
        }));
      }
    }
  } : {}));
};